export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14239.16de74f6.jpg";